import { render, staticRenderFns } from "./SlCardTable.vue?vue&type=template&id=28e124fc&"
import script from "./SlCardTable.vue?vue&type=script&lang=js&"
export * from "./SlCardTable.vue?vue&type=script&lang=js&"
import style0 from "./SlCardTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports